import {
  collection,
  doc,
  getDocs,
  updateDoc,
  addDoc,
  deleteDoc,
  Timestamp,
} from "firebase/firestore";
import { Contact, ClientFile } from "@visitproof/types";
import { db } from "../firebase";
import { clean } from "../utils/utils";

type File = ClientFile;


export const ContactService = {
  async createContact(
    contactData: Omit<Contact, "id" | "createdAt" | "updatedAt"> & { parentId: string },
  ): Promise<string> {
    const newContact: Omit<Contact, "id"> = {
      ...contactData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    const contactRef = await addDoc(
      collection(db, "parents", contactData.parentId, "contacts"),
      clean(newContact),
    );
    return contactRef.id;
  },

  async updateContact(
    contactId: string,
    updatedData: Partial<Omit<Contact, "id" | "createdAt">>,
  ): Promise<void> {
    const contactDocRef = doc(
      db,
      "parents",
      updatedData.parentId!,
      "contacts",
      contactId,
    );
    await updateDoc(contactDocRef, clean({
      ...updatedData,
      updatedAt: Timestamp.now(),
    }));
  },

  async deleteContact(contactId: string): Promise<void> {
    const contactDocRef = doc(collection(db, "contacts"), contactId);
    await deleteDoc(contactDocRef);
  },

  async getContactFiles(contactId: string): Promise<File[]> {
    const contactFilesSnapshot = await getDocs(
      collection(db, "contacts", contactId, "files"),
    );
    if (contactFilesSnapshot.empty) {
      return [];
    }
    return contactFilesSnapshot.docs.map(
      (doc) => ({ id: doc.id, ...doc.data() }) as File,
    );
  },
};
